// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1OBIT","errors":"Errors_errors__1QEyJ"};